export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "turnip.worker-93c2713760efb91f5a66.worker.js");
}
